import { Component, OnInit } from '@angular/core';
import { StoreVariantsEnum } from '@models/store.interface';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-deposit',
  template: ``,
})
export class DepositComponent implements OnInit {
  constructor(private uiService: UIService) {}

  ngOnInit() {
    this.uiService.openStoreModal(StoreVariantsEnum.deposit);
  }
}
